import React from "react";
import CreateListing from "./CreateListing"

const LandlordPage = () => {
  return (
    <>
      <CreateListing />
    </>
  );
};

export default LandlordPage;